import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import React, { useEffect, useState } from 'react';

import { paxTypesPropTypes, paxRulesPropTypes, labelsPropTypes } from './PropTypes';
import { validatePaxSelection } from './helpers';

import InputIncrement from '../Atoms/InputIncrement';
import Icon from '../Atoms/Icon';

const propTypes = exact({
  handleChange: PropTypes.func.isRequired,
  paxTypes: PropTypes.arrayOf(paxTypesPropTypes).isRequired,
  paxRules: paxRulesPropTypes.isRequired,
  selectedValues: PropTypes.oneOfType([PropTypes.object, PropTypes.arrayOf(PropTypes.object)])
    .isRequired,
  setErrorMessage: PropTypes.func.isRequired,
  // eslint-disable-next-line react/require-default-props
  labels: labelsPropTypes,
  setPaxSelection: PropTypes.func.isRequired,
  setIsCallToBook: PropTypes.func.isRequired,
  onUserInteraction: PropTypes.func.isRequired,
});

function PaxSelectorInput(props) {
  // Convert selectedValues array to paxSelection object format
  const paxSelection = props.selectedValues || {};
  const [validationErrors, setValidationErrors] = useState([]);
  const [hasInteracted, setHasInteracted] = useState(false);

  useEffect(() => {
    const errors = validatePaxSelection(
      paxSelection,
      props.paxRules,
      { ...props.labels },
      props.paxTypes,
      hasInteracted ? props.setIsCallToBook : () => {} // Only set CallToBook after user interaction
    );

    setValidationErrors(errors);

    // Only update error message if user has interacted and there are errors
    const errorMessage =
      hasInteracted && errors.length > 0 ? errors.map((error) => error.message).join('\n') : null;

    props.setErrorMessage(errorMessage);
    props.setPaxSelection(paxSelection);
  }, [JSON.stringify(paxSelection), hasInteracted]); // Run when paxSelection or hasInteracted changes

  const handlePaxChange = (key, value) => {
    if (!hasInteracted) {
      setHasInteracted(true);
    }
    props.handleChange(key, value);
  };

  return (
    <div className="PaxSelectorInput Booking_content Booking_content-inset">
      <h2 className="Booking_groupTitle">{props.labels?.paxSelectionHeadingText}</h2>
      <p className="Booking_groupDescription">{props.labels?.paxSelectionDescriptionText}</p>

      {hasInteracted && validationErrors.length > 0 && (
        <div className="PaxSelectorInput_error">
          <ul>
            {validationErrors.map((error, idx) => (
              // eslint-disable-next-line react/no-array-index-key
              <li key={idx}>
                <div className="PaxSelectorInput_errorMessage">
                  <Icon id="tooltip" /> {error.message}
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}

      <div className="PaxSelectorInput_paxSelectorForm">
        <div className="Booking_content Booking_content-inset">
          <div className="PaxTypes">
            {props.paxTypes.map(({ key, name, description }) => {
              const currentValue = paxSelection[key] || 0;

              return (
                <div className="PaxSelectorInput_paxTypes" key={key}>
                  <div className="PaxSelectorInput_field">
                    <InputIncrement
                      fieldID={key}
                      handleChange={(value) => handlePaxChange(key, value)}
                      selectedValue={currentValue}
                      maxValue={10000}
                    />
                  </div>
                  <div className="PaxSelectorInput_info">
                    <div className="PaxSelectorInput_label">{name}</div>
                    <div className="PaxSelectorInput_description">({description})</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

PaxSelectorInput.propTypes = propTypes;

export default PaxSelectorInput;
